import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-card-experiencia-resgatada',
  templateUrl: './card-experiencia-resgatada.component.html',
  styleUrls: ['./card-experiencia-resgatada.component.scss'],
})
export class CardExperienciaResgatadaComponent implements OnInit {
  @Input() public imagemSrc: string = '';
  @Input() public nome: string = '';
  @Input() public cacaus: number = 0;
  @Input() public unidades: number = 0;
  @Input() public dataResgate: Date = undefined;
  @Input() public dataValidade: Date = undefined;
  @Input() public dataEvento: Date = undefined;
  @Input() public quantidadeDisponivel: number = 0;
  @Input() public ehEstornada: boolean = false;
  @Input() public existePromocoesUsuarios: boolean = true;
  @Input() public mensagemValidade: string = '';
  @Input() public tipo: number = 0;
  @Input() public acompanhantes: string = '';
  @Input() public idExperienciaMembro: string = '';
  @Input() public nomeLocal: string = '';
  @Input() public cupons: any = [];
  @Input() public idsExperienciaMembro: any = [];
  @Input() public parceiroNome: string = '';
  @Input() public experienciaTexto: any;
  @Input() public experiencia: any = undefined;
  @Input() public parceiroViva: any;
  @Output() public onClickAbrirMapa: EventEmitter<null> = new EventEmitter();

  public quantidadeAcompanhantes: number = 0;
  public experienciaTipo: boolean = false;
  public experienciaExpirada: boolean = false;
  public experienciaExpiradaParceiro: boolean = false;
  public exibirTextoEstornada: boolean = false;
  public onClickExpandir: boolean = false;
  public existeDetalhamentoMomentoEspecial: boolean = false;

  public windowWidth: number = window.innerWidth;

  public observacoes: any[];
  public mecanicaResgate: any[] = [];

  public textoStatus: string = '';
  public iconeStatus: string = '';
  public iconeExpandir: string = '';
  public statusExpirado: boolean = false;
  public statusUtilizado: boolean = false;
  public statusDisponivel: boolean = false;
  public statusEstornado: boolean = false;
  public statusBeneficioEexpirado: boolean = false;
  public mostrarAcompanhante: boolean = false;

  public shortDescription: any;

  constructor() {}

  ngOnInit(): void {
    console.log(this.experiencia);
    this.tratarListaMecanicaResgate();
    this.tratarListaObservacoesResgate();
    const dataValidade = this.dataValidade.toString().split('T')[0].split('-');
    const dataExpiracao = new Date(
      Number(dataValidade[0]),
      Number(dataValidade[1]) - 1,
      Number(dataValidade[2]),
      23,
      59,
      59
    );

    if (this.parceiroViva) {
      const dataValidadeParceiro = this.parceiroViva?.ExpirationDate//this.parceiroViva?.expire_at
        .toString()
        .split('T')[0]
        .split('-');
      var dataExpiracaoParceiro = new Date(
        Number(dataValidadeParceiro[0]),
        Number(dataValidadeParceiro[1]) - 1,
        Number(dataValidadeParceiro[2]),
        23,
        59,
        59
      );
      this.experienciaExpiradaParceiro = new Date() > dataExpiracaoParceiro;

      this.shortDescription = this.removerHTMLTag(
        this.parceiroViva.Rules
      );
    }

    // if (this.parceiroViva) {
    //   this.shortDescription = this.removerHTMLTag(
    //     this.parceiroViva.product_data.info.short_description
    //   );
    // }

    this.experienciaExpirada = new Date() > dataExpiracao;

    if (this.ehEstornada && !this.existePromocoesUsuarios)
      this.exibirTextoEstornada = true;

    if (
      this.experiencia.detalhamentoMomentoEspecial == null ||
      this.experiencia.detalhamentoMomentoEspecial == undefined ||
      this.experiencia.detalhamentoMomentoEspecial == ''
    )
      this.tratarListaObservacoesResgate();
    else this.existeDetalhamentoMomentoEspecial = true;

    this.iconeStatus = this.iconeSrc();
    this.textoStatus = this.statusTexto();
  }

  private removerHTMLTag(text: any) {
    const textoSemTag = new DOMParser().parseFromString(text, 'text/html');

    return textoSemTag.body.textContent || '';
  }

  public retornaAcompanhantes() {
    let acompanhantesArray = this.acompanhantes?.split('#');
    if (this.acompanhantes !== '') {
      this.mostrarAcompanhante = true;
      return acompanhantesArray?.length;
    } else {
      this.mostrarAcompanhante = false;
    }
  }

  formatarMes(mes) {
    const meses = [
      'janeiro',
      'fevereiro',
      'março',
      'abril',
      'maio',
      'junho',
      'julho',
      'agosto',
      'setembro',
      'outubro',
      'novembro',
      'dezembro',
    ];
    return meses[mes];
  }

  public retornaDataFormatada() {
    let data = new Date(this.dataEvento);

    let dia = data.getDate();
    let mes = this.formatarMes(data.getMonth());
    let hora = data.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });

    let dataFormatada = dia + ' de ' + mes + ' - ' + hora;

    return dataFormatada;
  }

  public expandirCard() {
    this.onClickExpandir = !this.onClickExpandir;
  }

  public expandirCardMobile() {
    if (this.windowWidth <= 999) {
      this.onClickExpandir = !this.onClickExpandir;
    }
  }

  public abrirMapa(): void {
    this.onClickAbrirMapa.emit();
  }

  public iconeSrc(): string {
    this.statusBeneficioEexpirado = false;
    this.statusEstornado = false;
    this.statusExpirado = false;
    this.statusUtilizado = false;
    this.statusDisponivel = false;

    let src = 'assets/images/icons/';

    if (this.parceiroViva) {
      if (
        this.experienciaExpiradaParceiro &&
        !this.ehEstornada &&
        this.tipo !== 3 &&
        this.experiencia.quantidadeDisponivel > 0
      ) {
        src += 'relogio';
        this.statusExpirado = true;
      }

      if (this.ehEstornada) {
        src += 'estorno_momento';
        this.statusEstornado = true;
      }

      if (this.experiencia.quantidadeDisponivel == 0 && !this.ehEstornada) {
        src += 'utilizado';
        this.statusUtilizado = true;
      }

      if (
        this.experiencia.quantidadeDisponivel > 0 &&
        !this.experienciaExpiradaParceiro
      ) {
        src += 'disponivel';
        this.statusDisponivel = true;
      }

      if (this.experienciaExpiradaParceiro && this.tipo == 3) {
        src += 'beneficio_expirado';
        this.statusBeneficioEexpirado = true;
      }
    }

    if (!this.parceiroViva) {
      if (
        this.experienciaExpirada &&
        !this.ehEstornada &&
        this.tipo !== 3 &&
        this.experiencia.quantidadeDisponivel > 0
      ) {
        src += 'relogio';
        this.statusExpirado = true;
      }

      if (this.ehEstornada) {
        src += 'estorno_momento';
        this.statusEstornado = true;
      }

      if (this.experiencia.quantidadeDisponivel == 0 && !this.ehEstornada) {
        src += 'utilizado';
        this.statusUtilizado = true;
      }

      if (
        this.experiencia.quantidadeDisponivel > 0 &&
        !this.experienciaExpirada
      ) {
        src += 'disponivel';
        this.statusDisponivel = true;
      }

      if (this.experienciaExpirada && this.tipo == 3) {
        src += 'beneficio_expirado';
        this.statusBeneficioEexpirado = true;
      }
    }
    return src + '.svg';
  }

  public iconeExpandirSrc(): string {
    let src = 'assets/images/icons/';

    if (this.windowWidth > 999) {
      if (!this.onClickExpandir) {
        this.iconeExpandir = src += 'expandir';
      } else {
        this.iconeExpandir = src += 'retrair';
      }
    } else {
      if (!this.onClickExpandir) {
        this.iconeExpandir = src += 'expandir_mobile';
      } else {
        this.iconeExpandir = src += 'retrair_mobile';
      }
    }

    return src + '.svg';
  }

  public statusTexto(): string {
    if (this.parceiroViva) {
      if (
        this.experienciaExpiradaParceiro &&
        this.tipo == 3 &&
        this.experiencia.quantidadeDisponivel > 0
      )
        return 'Benefício expirado';
      if (
        this.experienciaExpiradaParceiro &&
        !this.ehEstornada &&
        this.experiencia.quantidadeDisponivel > 0
      )
        return 'Momento Especial expirado';
      if (this.ehEstornada) return 'Momento Especial estornado';
      if (
        this.experiencia.quantidadeDisponivel == 0 &&
        this.experiencia.parceiro.nome.includes('Cacau Show')
      )
        return 'Momento Especial utilizado';
      if (
        this.experiencia.quantidadeDisponivel > 0 &&
        !this.experienciaExpiradaParceiro
      )
        return 'Momento Especial disponível';
      
        return 'Momento Especial'; 
    }
    if (!this.parceiroViva) {
      if (
        this.experienciaExpirada &&
        this.tipo == 3 &&
        this.experiencia.quantidadeDisponivel > 0
      )
        return 'Benefício expirado';
      if (
        this.experienciaExpirada &&
        !this.ehEstornada &&
        this.experiencia.quantidadeDisponivel > 0
      )
        return 'Momento Especial expirado';
      if (this.ehEstornada) return 'Momento Especial estornado';
      if (
        this.experiencia.quantidadeDisponivel == 0 &&
        this.experiencia.parceiro.nome.includes('Cacau Show')
      )
        return 'Momento Especial utilizado';
      if (
        this.experiencia.quantidadeDisponivel > 0 &&
        !this.experienciaExpirada
      )
        return 'Momento Especial disponível';
    }
  }

  public quantidadeDisponivelTexto(): string {
    if (this.quantidadeDisponivel === undefined) return '';

    if (
      this.quantidadeDisponivel === 0 ||
      this.quantidadeDisponivel === this.unidades
    )
      return '';

    return `${this.quantidadeDisponivel} de ${this.unidades} disponível`;
  }

  public tratarListaMecanicaResgate() {
    let mecanicaResgate;

    if (
      this.experiencia.mecanicaResgate == undefined ||
      this.experiencia.mecanicaResgate == null
    ) {
      mecanicaResgate = _.filter(
        this.experiencia.experienciaTexto,
        (texto: any) => {
          return texto.titulo.toLowerCase().includes('mecânica de resgate');
        }
      );

      if (mecanicaResgate.length > 0) {
        const mecanicas = [];
        for (
          let i = 0;
          i < mecanicaResgate[0].experienciaParagrafo.length;
          i++
        ) {
          let paragrafo = mecanicaResgate[0].experienciaParagrafo[i];
          paragrafo.descricao = paragrafo.descricao.split('\r').join('');

          if (paragrafo.descricao !== '') mecanicas.push(paragrafo);
        }
        let descricaoNumerada = mecanicas;

        for (let n = 0; n < descricaoNumerada.length; n++) {
          let novoParagrafo = descricaoNumerada[n].descricao;
          novoParagrafo = novoParagrafo;
          this.mecanicaResgate.push(novoParagrafo);
        }
      } else {
        this.mecanicaResgate = undefined;
      }
    } else {
      var div = document.createElement('div');
      div.innerHTML = this.experiencia.mecanicaResgate.replaceAll(
        '<br>',
        String.fromCharCode(13)
      );
      var textContent = div.textContent || div.innerText;
      var paragrafos = textContent.split('\n');

      if (paragrafos.length > 0) {
        for (let x = 0; x < paragrafos.length; x++) {
          if (paragrafos[x] != '') {
            let novoParagrafo = paragrafos[x];
            novoParagrafo = novoParagrafo;
            this.mecanicaResgate.push(novoParagrafo);
          }
        }
      } else this.mecanicaResgate = undefined;
    }
  }
  public tratarListaObservacoesResgate() {
    this.observacoes = _.filter(
      this.experiencia.experienciaTexto,
      (texto: any) => {
        return !texto.titulo.toLowerCase().includes('mecânica de resgate');
      }
    );
  }
}
